export enum ActionTypes {
  // Family-tech
  START_FETCHING_TECH_FAMILIES = "START_FETCHING_TECH_FAMILIES",
  FETCH_TECH_FAMILIES_SUCCESS = "FETCH_TECH_FAMILIES_SUCCESS",
  FETCH_TECH_FAMILIES_FAIL = "FETCH_TECH_FAMILIES_FAIL",
  START_FETCHING_FIELDS_BY_FAMILY = "START_FETCHING_FIELDS_BY_FAMILY",
  FETCH_FIELDS_BY_FAMILY_SUCCESS = "FETCH_FIELDS_BY_FAMILY_SUCCESS",
  FETCH_FIELDS_BY_FAMILY_FAIL = "FETCH_FIELDS_BY_FAMILY_FAIL",
  // product-form
  UPDATE_PRODUCT_FORM = "UPDATE_PRODUCT_FORM",
  FILL_PRODUCT_FORM = "FILL_PRODUCT_FORM",
  REMOVE_PRODUCT_FILE = "REMOVE_PRODUCT_FILE",
  RESET_PRODUCT_FORM = "RESET_PRODUCT_FORM",
  RESET_TREE = "RESET_TREE",
  SEND_PRODUCT_FORM_FINISHED = "SEND_PRODUCT_FORM_FINISHED",
  SET_ERROR_TEXT_FROM_FIELD_PRODUCT_FORM = "SET_ERROR_TEXT_FROM_FIELD_PRODUCT_FORM",
  START_SENDING_PRODUCT_FORM = "START_SENDING_PRODUCT_FORM",
  CHANGE_PRODUCT_FILE_ORDER = "CHANGE_PRODUCT_FILE_ORDER",
  VALIDATE_PRODUCT = "VALIDATE_PRODUCT",
  CHANGE_FORM_LANG = "CHANGE_FORM_LANG",
  CLOSE_PRODUCT_FORM = "CLOSE_PRODUCT_FORM",
  OPEN_PRODUCT_FORM = "OPEN_PRODUCT_FORM",
  // LOCK_FIELD = "LOCK_FIELD",
  // UNLOCK_FIELD = "UNLOCK_FIELD",
  // login
  USER_LOG_OUT = "USER_LOG_OUT",
  // product-list
  START_FETCHING_PRODUCTS = "START_FETCHING_PRODUCTS",
  FETCH_PRODUCTS_SUCCESS = "FETCH_PRODUCTS_SUCCESS",
  FETCH_PRODUCTS_FAIL = "FETCH_PRODUCTS_FAIL",
  DELETE_PRODUCTS = "DELETE_PRODUCTS",
  SELECT_ROW = "SELECT_ROW",
  UNSELECT_ROW = "UNSELECT_ROW",
  UNSELECT_ALL_ROWS = "UNSELECT_ALL_ROWS",
  SELECT_ALL_ROWS = "SELECT_ALL_ROWS",
  TOOGLE_EXPAND_ROW = "TOOGLE_EXPAND_ROW",
  CLOSE_ALL_ROWS = "CLOSE_ALL_ROWS",
  SHOW_DELETED_PRODUCTS = "SHOW_DELETED_PRODUCTS",
  // loading
  START_LOADING = "START_LOADING",
  STOP_LOADING = "STOP_LOADING",
  REDIRECT = "REDIRECT",
  // tree
  LOAD_TREE = "LOAD_TREE",
  LOAD_TREE_DATA = "LOAD_TREE_DATA",
  LOAD_RAW_TREE_DATA = "LOAD_RAW_TREE_DATA",
  SET_FILTERED_DATA = "SET_FILTERED_DATA",
  TOOGLE_TREE_NODE = "TOOGLE_TREE_NODE",
  // supplierParameters
  UPDATE_SUPPLIER_PARAMETERS = "UPDATE_SUPPLIER_PARAMETERS",
  // lang
  CHANGE_LANG = "CHANGE_LANG",
  // multi_modif_modal
  CLOSE_MULTI_MODIF_MODAL = "CLOSE_MULTI_MODIF_MODAL",
  OPEN_MULTI_MODIF_MODAL = "OPEN_MULTI_MODIF_MODAL",
  FIELD_MODIFY_STATE_CHANGE = "FIELD_MODIFY_STATE_CHANGE",
  // Sidebar
  OPEN_SIDEBAR = "OPEN_SIDEBAR",
  CLOSE_SIDEBAR = "CLOSE_SIDEBAR",
  // User
  SET_ROLE = "SET_ROLE",
  SET_MANAGED_SUPPLIER_LIST = "SET_MANAGED_SUPPLIER_LIST",
  SET_SELECTED_SUPPLIER = "SET_SELECTED_SUPPLIER",
  SET_BUSINESS_UNIT = "SET_BUSINESS_UNIT",
  // Vat
  UPDATE_VAT = "UPDATE_VAT",
  UPDATE_TAXES = "UPDATE_TAXES",
  // Customs
  UPDATE_CUSTOMS = "UPDATE_CUSTOMS",
  // Territoi
  UPDATE_TERRITOI = "UPDATE_TERRITOI",
  // Brands
  UPDATE_BRANDS = "UPDATE_BRANDS",
  // Translations
  FETCH_TRANSLATIONS = "FETCH_TRANSLATIONS",
  // ISG URLS
  FETCH_ISG_URLS = "FETCH_ISG_URLS",
  // WARRANTY
  UPDATE_WARRANTY_LIST = "UPDATE_WARRANTY_LIST",
}
